module.exports = __webpack_public_path__ + "images/dingtalk_qrcode-092281c076d6551bb6b8d9ff1c30c1b8.png";